var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_576_2858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_576_2858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5V10.525V10.5V20.5V4.5ZM7 14.5H10.5C10.65 14.1167 10.8333 13.7583 11.05 13.425C11.2667 13.0917 11.5167 12.7833 11.8 12.5H7V14.5ZM7 18.5H10.175C10.0917 18.1667 10.0375 17.8333 10.0125 17.5C9.9875 17.1667 9.99167 16.8333 10.025 16.5H7V18.5ZM5 22.5C4.45 22.5 3.97917 22.3042 3.5875 21.9125C3.19583 21.5208 3 21.05 3 20.5V4.5C3 3.95 3.19583 3.47917 3.5875 3.0875C3.97917 2.69583 4.45 2.5 5 2.5H13L19 8.5V11C18.6833 10.8667 18.3583 10.7625 18.025 10.6875C17.6917 10.6125 17.35 10.5583 17 10.525V9.5H12V4.5H5V20.5H11.025C11.2917 20.9 11.5917 21.2708 11.925 21.6125C12.2583 21.9542 12.625 22.25 13.025 22.5H5ZM16.5 19.5C17.2 19.5 17.7917 19.2583 18.275 18.775C18.7583 18.2917 19 17.7 19 17C19 16.3 18.7583 15.7083 18.275 15.225C17.7917 14.7417 17.2 14.5 16.5 14.5C15.8 14.5 15.2083 14.7417 14.725 15.225C14.2417 15.7083 14 16.3 14 17C14 17.7 14.2417 18.2917 14.725 18.775C15.2083 19.2583 15.8 19.5 16.5 19.5ZM21.6 23.5L18.9 20.8C18.55 21.0333 18.1708 21.2083 17.7625 21.325C17.3542 21.4417 16.9333 21.5 16.5 21.5C15.25 21.5 14.1875 21.0625 13.3125 20.1875C12.4375 19.3125 12 18.25 12 17C12 15.75 12.4375 14.6875 13.3125 13.8125C14.1875 12.9375 15.25 12.5 16.5 12.5C17.75 12.5 18.8125 12.9375 19.6875 13.8125C20.5625 14.6875 21 15.75 21 17C21 17.4333 20.9417 17.8542 20.825 18.2625C20.7083 18.6708 20.5333 19.05 20.3 19.4L23 22.1L21.6 23.5Z",
    fill: "#1C1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach-money.709ce1ccf793b6a25de8c0cd4132080a.svg";
export { ForwardRef as ReactComponent };